import { render, staticRenderFns } from "./sp-feature-card-content-description.vue?vue&type=template&id=2bc452f6&scoped=true"
import script from "./sp-feature-card-content-description.vue?vue&type=script&lang=js"
export * from "./sp-feature-card-content-description.vue?vue&type=script&lang=js"
import style0 from "./sp-feature-card-content-description.vue?vue&type=style&index=0&id=2bc452f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc452f6",
  null
  
)

export default component.exports